module.exports = __webpack_public_path__ + "assets/img/02.a34cad61.png";